export default __webpack_public_path__ + "3f74d48c5fca189152c45f2e239cba6d.png";